export default __webpack_public_path__ + "static/ccpa-00f06b120e7335f3ba81012147450b14.pdf";